import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const MoneyIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}

            <g id="Icon/dinero">
                <g id="Group 177">
                    <path
                        id="Vector"
                        d="M10.5002 4.77271C7.34211 4.77271 4.77295 7.35024 4.77295 10.5187C5.06074 18.1311 15.9411 18.1292 16.2275 10.5187C16.2275 7.35024 13.6583 4.77271 10.5002 4.77271ZM10.9775 12.9128V13.3916C10.9751 14.0179 10.0253 14.0175 10.0229 13.3916V12.9128H9.89504C9.38579 12.9128 8.91043 12.6379 8.65508 12.195C8.52288 11.9657 8.60115 11.6731 8.82881 11.541C9.05743 11.4074 9.34952 11.4868 9.48077 11.7152C9.5662 11.8637 9.72465 11.9551 9.89456 11.9551H10.977C11.4529 11.9863 11.6657 11.213 11.1469 11.1124L9.69554 10.8696C8.02413 10.5589 8.38399 8.11493 10.0225 8.12451V7.64568C10.0253 7.01937 10.9746 7.01985 10.977 7.64568V8.12451H11.1049C11.6142 8.12451 12.0895 8.39983 12.3449 8.84275C12.4771 9.07163 12.3988 9.36419 12.1712 9.49683C11.9421 9.62947 11.6504 9.55094 11.5192 9.32206C11.4338 9.1741 11.2753 9.08264 11.1054 9.08264H10.0229C9.54711 9.05152 9.33472 9.82483 9.85304 9.92538L11.3044 10.1681C12.9758 10.4789 12.616 12.9224 10.9775 12.9128Z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    );
};

export default MoneyIcon;
